import { c as _c } from "react/compiler-runtime";
import { MapItemSUP } from "@/types/search";
import { PropertyDetailsCarousel } from "./carousel";
import { PreferenceCarousel } from "./preference-carousel";
interface PropertyOverlayContentProps {
  sups: MapItemSUP[];
  onToggleFavorite?: (property: MapItemSUP) => void;
  onShortlist?: (property: MapItemSUP) => void;
  isForPreference?: boolean;
  projectName?: string;
}
export function PropertyOverlayContent(t0) {
  const $ = _c(15);
  const {
    sups,
    onToggleFavorite,
    onShortlist,
    isForPreference: t1,
    projectName
  } = t0;
  const isForPreference = t1 === undefined ? false : t1;
  if (!sups || sups.length === 0) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex items-center justify-center h-64"><div className="text-gray-500">No properties available</div></div>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (isForPreference) {
    let t2;
    if ($[1] !== sups) {
      t2 = sups.map(_temp);
      $[1] = sups;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== onShortlist || $[4] !== onToggleFavorite || $[5] !== projectName || $[6] !== t2) {
      t3 = <PreferenceCarousel supIds={t2} projectName={projectName} onToggleFavorite={onToggleFavorite} onShortlist={onShortlist} className="border-0 shadow-none rounded-none" />;
      $[3] = onShortlist;
      $[4] = onToggleFavorite;
      $[5] = projectName;
      $[6] = t2;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  let t2;
  if ($[8] !== sups) {
    t2 = sups.map(_temp2);
    $[8] = sups;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== onShortlist || $[11] !== onToggleFavorite || $[12] !== projectName || $[13] !== t2) {
    t3 = <PropertyDetailsCarousel supIds={t2} projectName={projectName} onToggleFavorite={onToggleFavorite} onShortlist={onShortlist} className="border-0 shadow-none rounded-none" isForPreference={false} />;
    $[10] = onShortlist;
    $[11] = onToggleFavorite;
    $[12] = projectName;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}
function _temp2(sup_0) {
  return sup_0._id;
}
function _temp(sup) {
  return sup._id;
}